import { IconProps } from '@/types/icons';

export const IconPlus = ({ className }: Partial<IconProps>) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="40px"
      height="40px"
      viewBox="0 0 40 40"
      xmlSpace="preserve"
    >
      <path d="M20.0002 8.33334V31.6667M8.3335 20H31.6668" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
